import * as React from 'react';
import { scaleValue } from '../constants';
import LightTooltip from './LightTooltip';

export type ScaledValueProps = {
  className?: string;
  decimals?: number;
  showTooltip?: boolean;
  children?: React.ReactNode;
};

type Props = {
  base: number;
  value: number;
};

/**
 * This class is typically not rendered directly, but is instead intended to be composed
 * (wrapped) by a scaling widget that includes the base and units (children).
 */
export default class ScaledValue extends React.Component<
  Props & ScaledValueProps
> {
  render() {
    const {
      base,
      children,
      className,
      decimals = 0,
      showTooltip = true,
      value,
    } = this.props;
    const scaled = scaleValue(value, base, decimals);
    const widget = (
      <span className={className}>
        {scaled.num}
        <span className="scaled-value-suffix">
          {scaled.suffix}
          {children}
        </span>
      </span>
    );

    if (scaled.suffix && showTooltip) {
      // number is scaled, wrap it with a tooltip of the raw value if requested
      return (
        <LightTooltip tooltip={Number(value).toLocaleString()}>
          {widget}
        </LightTooltip>
      );
    }
    return widget;
  }
}
